import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Button, TableCell, Typography } from "@mui/material";
import React from "react";

import ApplicatorCompanyAPI from "../api/ApplicatorCompany.api";
import BasicCreateModal from "../components/BasicCreateModal";
import Layout from "../components/Layout";
import ListModel from "../components/ListModel";
import { ApplicatorCompany, TableColumn } from "../types";
import { extractDate } from "../utils";

const columns: TableColumn<ApplicatorCompany>[] = [
  { field: "name", label: "Name" },
  { field: "createdAt", label: "Created At Date" },
];

function buildTableRow(applicatorCompany: ApplicatorCompany): JSX.Element[] {
  return [
    <TableCell key={"name"}>{applicatorCompany.name}</TableCell>,
    <TableCell key={"createdAt"}>
      {extractDate(applicatorCompany.createdAt)}
    </TableCell>,
  ];
}

export default function ApplicatorCompanyListPage() {
  const [openModel, setOpenModal] = React.useState<boolean>(false);
  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Applicators</Typography>
          <Button onClick={() => setOpenModal(true)}>
            <AddCircleIcon />
          </Button>
        </Box>

        <ListModel
          defaultOrderBy={"name"}
          modelApiUseList={ApplicatorCompanyAPI.useList}
          modelBaseUrl={"applicator_companies"}
          columns={columns}
          buildTableRow={buildTableRow}
        />
        <BasicCreateModal
          open={openModel}
          onClose={() => setOpenModal(false)}
          modelApiUseSave={ApplicatorCompanyAPI.useSave}
          navigateUrl="/applicator_companies"
        />
      </Box>
    </Layout>
  );
}
